import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  ArrowDropDown as ClosedIcon,
  ArrowDropUp as OpenedIcon,
} from '@material-ui/icons';

import MainBarLink from './MainBarLink';
import { useDropdown } from '../../hooks';

const useStyles = makeStyles(({ palette, zIndex }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&:hover': {
      color: palette.navBar.hover,
    },
    cursor: 'pointer',
  },
  menu: {
    backgroundColor: palette.navBar.background,
    position: 'absolute',
    top: 65,
    zIndex: zIndex.appBar,
    padding: 10,
  },
  menuHidden: {
    display: 'none',
  },
}), { name: 'MainBarDropdown' });

const suppressEvent = (e: React.SyntheticEvent) => {
  e.stopPropagation();
  e.preventDefault();

  return false;
};

type Props = React.ComponentProps<typeof MainBarLink> & {
  title: React.ReactNode;
};

const MainBarDropdown = ({
  className, children, title, ...props
}: Props) => {
  const classes = useStyles();

  const {
    isOpened,
    open,
    close,
  } = useDropdown();

  return (
    <div
      className={clsx(classes.root, className)}
      onMouseEnter={open}
      onMouseLeave={close}
    >
      <MainBarLink
        onClick={suppressEvent}
        {...props}
      >
        <div>{title}</div>
        {isOpened ? <OpenedIcon /> : <ClosedIcon />}
      </MainBarLink>
      <div className={clsx(classes.menu, {
        [classes.menuHidden]: !isOpened,
      })}
      >
        {children}
      </div>
    </div>
  );
};

export default MainBarDropdown;
